export const FETCH_USER = "fetch_user";

export const FETCH_DISPLAYS = "fetch_displays";
export const FETCH_DISPLAY = "fetch_display";

export const FETCH_LOCATIONS = "fetch_locations";
export const FETCH_LOCATION = "fetch_location";
export const FETCH_LOCATION_USERS = "fetch_location_users";
export const FETCH_LOCATION_USER = "fetch_location_user";
export const FETCH_USER_LOCATIONS = "fetch_user_locations";

export const FETCH_MENUS = "fetch_menus";
export const FETCH_MENU = "fetch_menu";

export const FETCH_MENU_ITEMS = "fetch_menu_items";
export const FETCH_MENU_ITEM = "fetch_menu_item";

export const FETCH_MENU_ITEMS_MEDIA = "fetch_menu_items_media";
export const FETCH_MENU_ITEM_MEDIA = "fetch_menu_item_media";

export const FETCH_MEDIAS = "fetch_medias";
export const FETCH_MEDIA = "fetch_media";

export const FETCH_GROUPS = "fetch_groups";
export const FETCH_GROUP = "fetch_group";

export const FETCH_PRODUCTS = "fetch_products";
export const FETCH_PRODUCT = "fetch_product";

export const FETCH_BRANDS = "fetch_brands";
export const FETCH_COLORS = "fetch_colors";
export const FETCH_CATEGORIES = "fetch_categories";
export const FETCH_SORT_OPTIONS = "fetch_sort_options";
export const FETCH_STRAIN_TYPES = "fetch_strain_types";
export const FETCH_SUBSCRIPTION = "fetch_subscription";
export const FETCH_TERPENE_PROFILES = "fetch_terpene_profiles";
export const FETCH_THEMES = "fetch_themes";

export const FETCH_ZOHO_CUSTOMERS = "fetch_zoho_customers";
